/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class Navbar extends HTMLElement {
  constructor () {
    super()

    this.scrollOptions = { passive: true }
    this.dropdownHandlers = []
  }

  connectedCallback () {
    if (this.connected) return
    this.connected = true

    this.handleDropdownsBackdrop()
    this.handleHeaderReveal()
    this.adjustOffcanvasMenu()
  }

  disconnectedCallback () {
    if (!this.connected) return
    this.offcanvasMenu?.removeEventListener('show.bs.offcanvas', this.handleOffcanvasShow)
    this.offcanvasMenu?.removeEventListener('hide.bs.offcanvas', this.handleOffcanvasHide)
    window.removeEventListener('scroll', this.handleScroll, this.scrollOptions)
    this.dropdownHandlers.forEach(({ dropdown, type, handler }) => dropdown.removeEventListener(type, handler))
    this.dropdownHandlers = []
    this.connected = false
  }

  adjustOffcanvasMenu () {
    const offcanvasMenu = document.querySelector('#offcanvas-menu')
    const navbarMobile = document.querySelector('#navbar-mobile')

    this.offcanvasMenu = offcanvasMenu
    this.handleOffcanvasShow = () => {
      const navbarSpacing = navbarMobile.getBoundingClientRect().bottom
      offcanvasMenu.style.height = `${window.innerHeight - navbarSpacing}px`

      navbarMobile.querySelector('.svg-icon-menu')?.classList.add('svg-icon-menu-close')
    }

    this.handleOffcanvasHide = () => {
      navbarMobile.querySelector('.svg-icon-menu')?.classList.remove('svg-icon-menu-close')
    }
    offcanvasMenu?.addEventListener('show.bs.offcanvas', this.handleOffcanvasShow)
    offcanvasMenu?.addEventListener('hide.bs.offcanvas', this.handleOffcanvasHide)
  }

  handleHeaderReveal () {
    let oldScroll = window.scrollY
    const headerGroup = document.querySelector('#header-group')

    this.handleScroll = () => {
      const newScroll = window.scrollY
      if (newScroll > oldScroll) {
        if (newScroll > headerGroup.clientHeight) {
          headerGroup.classList.add('hide')
        }
      } else if (newScroll < oldScroll) {
        headerGroup.classList.remove('hide')
      }

      oldScroll = Math.max(window.scrollY, 0)
    }
    window.addEventListener('scroll', this.handleScroll, this.scrollOptions)
  }

  handleDropdownsBackdrop () {
    this.querySelectorAll('#navbar-desktop .dropdown-toggle').forEach(dropdown => {
      const hiddenHandler = () => {
        if (!document.querySelector('#navbar-desktop .dropdown-toggle.show')) {
          document.body.classList.remove('navbar-dropdown-open')
        }
      }
      const showHandler = () => {
        document.body.classList.add('navbar-dropdown-open')
      }
      dropdown.addEventListener('hidden.bs.dropdown', hiddenHandler)
      dropdown.addEventListener('show.bs.dropdown', showHandler)
      this.dropdownHandlers.push(
        { dropdown, type: 'hidden.bs.dropdown', handler: hiddenHandler },
        { dropdown, type: 'show.bs.dropdown', handler: showHandler }
      )
    })
  }
}
customElements.define('navbar-wrapper', Navbar)
